import { logger, type Metrics } from '@moonpig/web-core-monitoring'
import {
  getAuthBaseUrl,
  isAuthData,
  isServer as checkServer,
  getAuthSecretHeader,
} from './utils'
import { AuthData } from './types'
import { HEADER_SESSION_ID } from './constants'
import { DedupeFetch } from './dedupeFetchJson'
import { getAuthCursorSecretHeader } from './tunnelSecretHeaders'

export const fetchAccessToken = async ({
  sessionId,
  metrics,
  fetch,
}: {
  sessionId?: string
  metrics: Metrics
  fetch: DedupeFetch
}): Promise<AuthData | undefined> => {
  const baseUrl = getAuthBaseUrl()

  const isServer = checkServer()
  // eslint-disable-next-line compat/compat -- Feature detection added for Safari 15.1-15.8 compatibility
  const cookieEnabled = globalThis.navigator?.cookieEnabled ?? true
  const url = isServer
    ? `${baseUrl}/token`
    : `${baseUrl}/token?ce=${cookieEnabled}`

  const headers: { [key: string]: string } = {
    ...(isServer ? getAuthSecretHeader() : {}),
    ...(isServer ? getAuthCursorSecretHeader() : {}),
    ...(sessionId ? { [HEADER_SESSION_ID]: sessionId } : {}),
  }

  const response = await metrics.traceAsync(
    {
      traceName: 'fetch-auth-token',
      metricName: 'fetch-auth-token',
    },
    () =>
      fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers,
      }),
  )

  if (!response.ok) {
    throw new Error(`Fetch auth token response ${response.statusText}`)
  }

  if (isServer) {
    const data = response.json
    if (isAuthData(data)) {
      return data
    }

    logger.fixToday('Error fetching access token: invalid auth data')
  }
}
